import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { computedFrom } from "aurelia-binding";
import { Router } from 'aurelia-router';
import { StringHelper } from '../../../../Code/Helpers/StringHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { BaseView } from 'Common/BaseView';
import { Toastr } from 'Code/Extension/Toastr';
import { AuthService } from 'DataAccessLayer/Services/AuthService';

declare var Swiper;
declare var bootstrap;

@autoinject
export class OperatorProfileBaseView extends BaseView {

  @bindable({ defaultBindingMode: bindingMode.twoWay }) entityName: string = 'Operator';
  @bindable({ defaultBindingMode: bindingMode.toView }) entityId: number = null;
  @bindable({ defaultBindingMode: bindingMode.toView }) operatorData: any = null;

  private authService: AuthService = null;
  private element: any = null;
  protected dataService: DataService = null;
  private aircraftList: Array<any> = [];

  private myModal: any = null;
  private quoteRequestText: string = null;
  private userName: string = null;
  private isLogged: boolean = false;

  constructor(element: Element, dataService: DataService, authService: AuthService) {
    super();
    this.element = element;
    this.dataService = dataService;
    this.authService = authService;

    this.userName = this.authService.GetUserInfo().UserName;
    this.isLogged = StringHelper.StringIs(this.userName) && this.userName != 'PublicUser';
  }
  activate(params, routeConfig, $navigationInstruction) {
    this.entityId = params.entityId;
  }
  async bind() {
    let response: any = await this.dataService.GetById('Operator', this.entityId);
    if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response.data)) {
      this.operatorData = response.data;

      this.aircraftList = [];
      let params: any = {
        OperatorId: this.entityId,
        RequestCounter: 1
      }
      let apiResponse: any = await this.dataService.GetSpData('sp_BirdReviewOperatorAircrafts', params);
      if (ObjectHelper.ObjectIs(apiResponse) && ObjectHelper.ObjectIs(apiResponse.data)) {
        const spData: any = JSON.parse(JSON.stringify(apiResponse.data));
        if (ObjectHelper.ObjectIs(spData) && ObjectHelper.ArrayIs(spData.Aircrafts)) {
          this.aircraftList = JSON.parse(JSON.stringify(spData.Aircrafts));
        }
      }
    }
  }

  private ShowQuoteRequestModalOpen() {
    this.myModal = new bootstrap.Modal(document.getElementById(`QuoteRequestModal${this.guid}`));
    this.myModal.show();
  }

  private ShowQuoteRequestModalClose() {
    this.myModal.hide();
    this.myModal = null;
  }

  private async ShowQuoteRequestModalSend() {
    let newTask: any = null;
    let response: any = await this.dataService.GetById('Task', 0);
    if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response.data)) {
      newTask = JSON.parse(JSON.stringify(response.data));
    }

    newTask.c_Operator_FK = this.entityId * 1;
    newTask.Type_FK = 1277 //	Quote Request
    newTask.Description = this.quoteRequestText;

    let resposne = await this.dataService.Create('Task', newTask);
    switch (resposne['status']) {
      case 'OK': {
        Toastr.Success('Toastr.Done', 'Toastr.SavingFormWasSuccessful');
        this.ShowQuoteRequestModalClose();
        break;
      }
      default: {
        Toastr.Error('Toastr.Oooops', resposne['message'], false);
        break;
      }
    }

  }

}
